import React, { useState, useEffect } from 'react';

const WhoAreWe = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);
  
  return (
    <div className='whoBg'>
      <div className='who-we-are'>
        {pages.map((page) => {
          if (page.slug === 'who-we-are-2') {
            return <div className='inner' dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
          }
        })}
      </div>   
    </div> 
  );
}

export default WhoAreWe;